export class Checkeable <T> {

 inner: T;
 checked: boolean;

  constructor(inner: T) {
    this.inner = inner;
    this.checked = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/productos/producto-validar-datos/checkeable.model.ts